import { render, staticRenderFns } from "./KanbanSearch.vue?vue&type=template&id=2364d1c8&scoped=true&"
import script from "./KanbanSearch.vue?vue&type=script&lang=js&"
export * from "./KanbanSearch.vue?vue&type=script&lang=js&"
import style0 from "./KanbanSearch.vue?vue&type=style&index=0&id=2364d1c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2364d1c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
